import CatRunningRankingScreen from './components/CatRunningRankingScreen';

export default function CatRunningRankingPage() {
  return <CatRunningRankingScreen />;
}
